//
//
//
//
//
//
//
//
//

export default {
  props: ["text", "icon"],
  methods: {
    scroll() {
      if (this.$refs.scrollTip) {
        if (window.scrollY > 250) {
          this.$refs.scrollTip.style.opacity = 0;
        } else {
          this.$refs.scrollTip.style.opacity = 1;
        }
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", this.scroll, false);
  }
};



// WEBPACK FOOTER //
// ./src/components/Tips/Tips.vue